import Box from '@mui/material/Box';
import { type Theme } from '@mui/material/styles';
import { memo, type FormEventHandler, type ReactNode } from 'react';

interface Props {
  onSubmit: FormEventHandler<HTMLFormElement>;
  children: ReactNode;
}

/**
 * Auth forms use Signal's comfortable field size (48px, r14, 16px text) instead of the
 * dense product inputs, so the theme components stay untouched everywhere else.
 */
const AuthForm = ({ onSubmit, children }: Props) => (
  <Box component="form" noValidate onSubmit={onSubmit} sx={sx.form}>
    {children}
  </Box>
);

export default memo(AuthForm);

const sx = {
  form: (theme: Theme) => ({
    display: 'flex',
    flexDirection: 'column' as const,
    gap: 2,
    '& .MuiFormLabel-root': {
      fontFamily: theme.typography.subtitle1.fontFamily,
      fontSize: 14,
      fontWeight: 500,
      lineHeight: 1.2,
      mb: 1,
    },
    '& .MuiOutlinedInput-root': {
      height: 48,
      px: 2,
      gap: '10px',
      borderRadius: '14px',
      fontSize: 16,
    },
    '& .MuiOutlinedInput-root .MuiSvgIcon-root': { fontSize: 20 },
    '& .MuiInputAdornment-positionStart': { mr: 0 },
    '& .MuiFormHelperText-root': { mx: 0, mt: '6px' },
    '& .MuiFormControlLabel-root': { alignItems: 'flex-start', gap: '2px' },
    '& .MuiFormControlLabel-label, & .MuiFormControlLabel-label *': {
      fontSize: 14,
      lineHeight: 1.4,
    },
  }),
};
